declare global {
  interface Window {
    dataLayer: object[]
  }
}

interface IPushDataLayer {
  event: string
  keyword: string
}

type PushDataLayer = (data: IPushDataLayer) => void

export const pushDataLayer: PushDataLayer = (data: IPushDataLayer) => {
  window.dataLayer.push(data)
}
